module.exports = __webpack_public_path__ + "static/img/logo.d457388f.png";